export type IconType = {
  iconVariant: IconVariant;
  className?: string;
  isPointer?: boolean;
  icon: string;
  color?: IconColor;
  size?: IconSize;
  onClick?: () => void;
  dataCy?: string;
  ariaLabel?: string;
};

export enum IconSize {
  huge = '25px',
  large = '20px',
  medium = '15px',
  small = '10px',
  tiny = '5px',
}

export enum IconColor {
  light = '#fff',
  dark = '#000',
  primary = '#007698',
  inherit = 'inherit',
}

export enum IconVariant {
  FontAwesome = 'FontAwesome',
  Custom = 'Custom',
}
